export default __webpack_public_path__ + "static/media/blank_image.09cb794a.png";